$(window).on('scroll', function(){
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $(".forsticky").addClass("sticky");
    }
    else{
        $(".forsticky").removeClass("sticky");
        $(".forsticky").addClass("");
    }
});
$(".responsivemenu .menu-item-has-children > a").on("click",function(){
    $(this).parent().siblings().children("ul").slideUp();
    $(this).parent().siblings().removeClass("active");
    $(this).parent().children("ul").slideToggle();
    $(this).parent().toggleClass("active");
});
$(".responsivemenu > ul > li > a").on("click",function(){
    console.log('click on menu');
    $('.responsive-header').removeClass('active');
    $('.responsive-opensec').slideUp();
    $('.res-openmenu').removeClass('active')
    $('.res-closemenu').addClass('active');
});
$('.res-openmenu').on('click', function(){
    $('.responsive-header').addClass('active');
    $('.responsive-opensec').slideDown();
    $('.res-closemenu').removeClass('active')
    $(this).addClass('active');
});
$('.res-closemenu').on('click', function(){
    $('.responsive-header').removeClass('active');
    $('.responsive-opensec').slideUp();
    $('.res-openmenu').removeClass('active')
    $(this).addClass('active');
});

function changeRacLogo(event){
    let clickedElem = event.currentTarget;
    let imgPathUrl = event.currentTarget.value;
    let imgPath = URL.createObjectURL(event.target.files[0]);
    let parentElem = clickedElem.parentElement;
    let rootElem = parentElem.parentElement;
    let showenImg = rootElem.querySelector('.logoshow');
    console.log(showenImg);
    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
    if (!allowedExtensions.exec(imgPathUrl)) {
        alert('Invalid file type');
        return false;
    }else{
        showenImg.innerHTML = "<img src="+imgPath+" class='w100'>";
        showenImg.querySelector('.w100').style.width = 100+"%";
    }
}